export const mutations = {
  setAllUser: function (state, emp) {
    state.alluser = emp;
  },

  deleteUser: function (state, user) {
    var index = [...state.alluser].findIndex((e) => e.user_id == user.user_id);
    if (index > -1) {
      state.alluser[index] = user;
    }
  },
};
